import { Route as PurchaseOrderRoute } from "@/routes/(pharma)/_layout/reports/purchase-order-list/index";
import { useQuery } from "@tanstack/react-query";
import { getPurchaseOrders } from "../-data/api";

interface PurchaseOrderQueryResult {
  purchaseOrders: any[];
  totalCount: number;
}

export const usePurchaseOrderData = () => {
  const searchParams = PurchaseOrderRoute.useSearch();
  
  return useQuery<PurchaseOrderQueryResult>({
    queryKey: ["purchase-orders", searchParams],
    queryFn: async () => {
      return await getPurchaseOrders(
        searchParams.page || 1,
        searchParams.pageSize || 10,
      );
    },
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: true,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};